if (typeof AnimatedFeaturedProduct !== 'function') {
	class AnimatedFeaturedProduct extends HTMLElement {
		constructor() {
			super();

			this.classes = {
				mainClass: 'animated-featured-product',
				gridTwoMobile: 'grid--two-mobile',
				gridRightOrientationMobile: 'grid--mobile-right',
			};

			this.animatedFeaturedProduct;
			this.imagesGrid = this.querySelector('.animated-featured-product__grid');
			this.firstImageWrapper = this.querySelector('.grid__secondary-image:first-child');
			this.secondImageWrapper = this.querySelector('.grid__main-image');
			this.thirdImageWrapper = this.querySelector('.grid__secondary-image:last-child');
			this.speedOnDesktop = +this.dataset.animation.split('-').at(0) / 100;
			this.speedOnMobile = +this.dataset.animation.split('-').at(1) / 100;
			this.animationFrameId = null;

			this.debouncedHandleScroll = this.debounce(this.handleScroll.bind(this), 20);

			this.init();

			if (window.Shopify.designMode) {
				document.addEventListener('shopify:section:load', () => {
					this.imagesGrid.style.opacity = 1;
					this.init();
				});
			}
		}

		connectedCallback() {
			this.initObserver();
		}

		init() {
			window.addEventListener('load', () => {
				this.handleScroll();
				this.imagesGrid.style.opacity = 1;
			});

			window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
		}

		initObserver() {
			const options = {
				root: null,
				rootMargin: '600px 0px',
				threshold: 0.5,
			};

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.animatedFeaturedProduct = entry.target; // Set the variable inside the callback
					} else {
						this.animatedFeaturedProduct = false;
					}
				});
			}, options);

			observer.observe(this);
		}

		debounce(func, delay) {
			let timeoutId;

			return function () {
				clearTimeout(timeoutId);

				timeoutId = setTimeout(() => {
					func.apply(this, arguments);
				}, delay);
			};
		}

		handleScroll() {
			if (!this.animatedFeaturedProduct) {
				return;
			}

			this.animationFrameId = requestAnimationFrame(() => {
				const intersecting = this.animatedFeaturedProduct.classList.contains(this.classes.mainClass);

				if (intersecting) {
					const distanceFromTop =
						this.animatedFeaturedProduct.getBoundingClientRect().top - window.innerHeight;

					let translateFirst,
						translateSecond,
						translateThird = 0;
					let translate1,
						translate2,
						translate3 = [];

					if (window.innerWidth >= 1024) {
						translateFirst = translateSecond = translateThird = -distanceFromTop * this.speedOnDesktop;
						translate1 = [translateFirst, -translateFirst];
						translate2 = [0, -translateSecond];
						translate3 = [-translateThird * 1.2, -translateThird * 0.6];

						this.firstImageWrapper.style.transform = `translate(${translate1[0]}px, ${translate1[1]}px)`;
						this.secondImageWrapper.style.transform = `translate(${translate2[0]}px, ${translate2[1]}px)`;
						this.thirdImageWrapper.style.transform = `translate(${translate3[0]}px, ${translate3[1]}px)`;

						return;
					} else if (window.innerWidth >= 768) {
						translateFirst = translateThird = -distanceFromTop * this.speedOnDesktop;
						translateSecond = -distanceFromTop * this.speedOnMobile;
						translate1 = [translateFirst * 0.7, -translateFirst];
						translate2 = [0, -translateSecond];
						translate3 = [-translateThird * 1.2, -translateThird * 0.6];

						this.firstImageWrapper.style.transform = `translate(${translate1[0]}px, ${translate1[1]}px)`;
						this.secondImageWrapper.style.transform = `translate(${translate2[0]}px, ${translate2[1]}px)`;
						this.thirdImageWrapper.style.transform = `translate(${translate3[0]}px, ${translate3[1]}px)`;

						return;
					} else {
						translateFirst = translateSecond = translateThird = -distanceFromTop * this.speedOnMobile;
						translate2 = [translateSecond * 0.3, -translateSecond];

						if (this.imagesGrid.classList.contains(this.classes.gridTwoMobile)) {
							translate1 = [-translateFirst * 0.3, translateFirst];
							translate3 = [0, 0];
						} else {
							translate1 = [translateFirst * 0.2, translateFirst];
							translate3 = [translateThird * 0.5, translateThird * 0.5];
						}

						if (this.imagesGrid.classList.contains(this.classes.gridRightOrientationMobile)) {
							this.firstImageWrapper.style.transform = `translate(${-translate1[0]}px, ${
								translate1[1]
							}px)`;
							this.secondImageWrapper.style.transform = `translate(${-translate2[0]}px, ${
								translate2[1]
							}px)`;
							this.thirdImageWrapper.style.transform = `translate(${translate3[0]}px, ${translate3[1]}px)`;
						} else {
							this.firstImageWrapper.style.transform = `translate(${translate1[0]}px, ${translate1[1]}px)`;
							this.secondImageWrapper.style.transform = `translate(${translate2[0]}px, ${translate2[1]}px)`;
							this.thirdImageWrapper.style.transform = `translate(${-translate3[0]}px, ${
								translate3[1]
							}px)`;
						}

						return;
					}
				} else {
					this.animatedFeaturedProduct = false;
				}
			});
		}
	}

	if (!customElements.get('animated-featured-product')) {
		customElements.define('animated-featured-product', AnimatedFeaturedProduct);
	}
}
